import { defineMessages } from 'react-intl';

/** The copy of the inbox and the reply thread (design outreach-v2 m1 to m4). */
export const inboxMessages = defineMessages({
  title: { id: 'app.outreach.inbox.title', defaultMessage: 'Inbox' },
  intro: {
    id: 'app.outreach.inbox.intro2',
    defaultMessage:
      "Replies to Plug's pitches, from all your mailboxes. Plug reads only the answers to its own emails, never the rest of your mail.",
  },
  // Navigation v2 (design d 4f). `intro` stays for the native apps, which read its id.
  subtitle: {
    id: 'app.outreach.inbox.subtitle',
    defaultMessage: "Replies to Plug's pitches, from your connected mailboxes.",
  },
  campaign: { id: 'app.outreach.inbox.campaign', defaultMessage: 'Campaign' },
  allCampaigns: { id: 'app.outreach.inbox.allCampaigns', defaultMessage: 'All campaigns' },

  groupNeedsYou: { id: 'app.outreach.inbox.group.needsYou', defaultMessage: 'Needs you' },
  groupAdded: { id: 'app.outreach.inbox.group.added', defaultMessage: 'Added your song' },
  groupDone: { id: 'app.outreach.inbox.group.done', defaultMessage: 'Done' },
  groupHidden: { id: 'app.outreach.inbox.group.hidden', defaultMessage: 'Hidden' },
  hiddenSummary: {
    id: 'app.outreach.inbox.hidden.summary',
    defaultMessage:
      '{outOfOffice} out-of-office · {bounces, plural, one {# bounce} other {# bounces}} · {unsubscribes} unsubscribed',
  },
  hiddenSub: { id: 'app.outreach.inbox.hidden.sub', defaultMessage: 'Plug handled these. Nothing to do.' },
  nothingNeedsYou: { id: 'app.outreach.inbox.group.nothingNeedsYou', defaultMessage: 'Nothing needs you right now.' },
  asksChip: { id: 'app.outreach.inbox.asksChip', defaultMessage: 'Asks: {asks}' },
  askShortLink: { id: 'app.outreach.inbox.ask.short.link', defaultMessage: 'link' },
  askShortReleaseDate: { id: 'app.outreach.inbox.ask.short.releaseDate', defaultMessage: 'date' },
  askShortWav: { id: 'app.outreach.inbox.ask.short.wav', defaultMessage: 'WAV' },
  askShortPressPhoto: { id: 'app.outreach.inbox.ask.short.pressPhoto', defaultMessage: 'photo' },
  askShortLyrics: { id: 'app.outreach.inbox.ask.short.lyrics', defaultMessage: 'lyrics' },
  askShortStory: { id: 'app.outreach.inbox.ask.short.story', defaultMessage: 'story' },
  askShortOther: { id: 'app.outreach.inbox.ask.short.other', defaultMessage: 'other' },

  labelInterested: { id: 'app.outreach.inbox.label.interested', defaultMessage: 'Interested' },
  labelPlaced: { id: 'app.outreach.inbox.label.placed', defaultMessage: 'Placed' },
  labelNotAFit: { id: 'app.outreach.inbox.label.notAFit', defaultMessage: 'Not a fit' },
  labelAsksForPayment: { id: 'app.outreach.inbox.label.asksForPayment', defaultMessage: 'Asks for payment' },
  labelLater: { id: 'app.outreach.inbox.label.later', defaultMessage: 'Later' },
  labelOutOfOffice: { id: 'app.outreach.inbox.label.outOfOffice', defaultMessage: 'Out of office' },
  labelUnsubscribe: { id: 'app.outreach.inbox.label.unsubscribe', defaultMessage: 'Unsubscribe' },
  labelBounce: { id: 'app.outreach.inbox.label.bounce', defaultMessage: 'Bounce' },
  labelOther: { id: 'app.outreach.inbox.label.other', defaultMessage: 'Other' },
  changeLabel: { id: 'app.outreach.inbox.changeLabel', defaultMessage: 'Label' },

  emptyTitle: { id: 'app.outreach.inbox.empty2.title', defaultMessage: 'Nothing needs you right now' },
  emptyBody: {
    id: 'app.outreach.inbox.empty2.body',
    defaultMessage: 'Replies usually come 2 to 6 days after a pitch. We send a push for each one.',
  },
  emptyOpenCampaign: { id: 'app.outreach.inbox.empty2.openCampaign', defaultMessage: 'Open the campaign' },
  emptyOpenPitch: { id: 'app.outreach.inbox.empty2.openPitch', defaultMessage: 'Open Pitch' },
  pickThread: { id: 'app.outreach.inbox.pick', defaultMessage: 'Pick a reply to read it.' },
  back: { id: 'app.outreach.inbox.back', defaultMessage: 'All replies' },

  listened: {
    id: 'app.outreach.thread.listened',
    defaultMessage: 'Listened {time} on your pitch page{plays, plural, =1 {} other {, # times}}',
  },
  you: { id: 'app.outreach.thread.you', defaultMessage: 'You' },
  from: { id: 'app.outreach.thread.from', defaultMessage: 'From {address}' },
  placedTitle: { id: 'app.outreach.thread.placed.title', defaultMessage: '{song} is on {playlist} since {date}' },
  placedDetected: {
    id: 'app.outreach.thread.placed.detected',
    defaultMessage: 'Found by MUSIC24 in the playlist data. They did not answer, and that is normal.',
  },
  placedPosition: { id: 'app.outreach.thread.placed.position', defaultMessage: 'Position {position}' },
  placedWatch: { id: 'app.outreach.thread.placed.watch', defaultMessage: 'MUSIC24 watches this playlist for 60 days.' },
  // design g2: fixed copy, never AI text, and no suggested answer.
  paymentTitle: { id: 'app.outreach.thread.payment.title', defaultMessage: 'Do not pay for a playlist placement.' },
  paymentBody: {
    id: 'app.outreach.thread.payment.body',
    defaultMessage:
      'Paying for a placement breaks Spotify\'s rules and can get your song removed. "Guaranteed streams" often means bots. MUSIC24 marked this curator.',
  },
  notPayment: { id: 'app.outreach.thread.payment.mistake', defaultMessage: 'This is a mistake' },
  archive: { id: 'app.outreach.thread.archive', defaultMessage: 'Archive' },
  suggested: { id: 'app.outreach.thread.plugAnswer', defaultMessage: "Plug's answer" },
  thankYouTitle: { id: 'app.outreach.thread.thankYouTitle', defaultMessage: 'A short thank-you' },
  skip: { id: 'app.outreach.thread.skip', defaultMessage: 'Skip' },

  theyAsk: { id: 'app.outreach.thread.asks.title', defaultMessage: 'They ask for' },
  askLink: { id: 'app.outreach.thread.ask.link', defaultMessage: 'Spotify link' },
  askReleaseDate: { id: 'app.outreach.thread.ask.releaseDate', defaultMessage: 'Release date' },
  askWav: { id: 'app.outreach.thread.ask.wav', defaultMessage: 'WAV' },
  askPressPhoto: { id: 'app.outreach.thread.ask.pressPhoto', defaultMessage: 'Press photo' },
  askLyrics: { id: 'app.outreach.thread.ask.lyrics', defaultMessage: 'Lyrics' },
  askStory: { id: 'app.outreach.thread.ask.story', defaultMessage: 'The story of the song' },
  askOther: { id: 'app.outreach.thread.ask.other', defaultMessage: 'Something else' },
  attachments: { id: 'app.outreach.thread.attachments', defaultMessage: 'Add to the answer' },
  pressPhotoMissing: {
    id: 'app.outreach.thread.pressPhotoMissing',
    defaultMessage: 'No press photo of {song} yet.',
  },
  pressPhotoMake: { id: 'app.outreach.thread.pressPhotoMake', defaultMessage: 'Make one in Studio' },
  reminderAsk: {
    id: 'app.outreach.thread.reminder.ask',
    defaultMessage: 'Send the live link again on release day',
  },
  reminderSet: { id: 'app.outreach.thread.reminder.set', defaultMessage: 'Send the live link again on {date}' },
  reminderFailed: {
    id: 'app.outreach.thread.reminder.failed',
    defaultMessage: 'Plug cannot set this. Set the release day of the song first, or send the link now.',
  },

  aboutTitle: { id: 'app.outreach.thread.side.about', defaultMessage: 'About {name}' },
  aboutSong: { id: 'app.outreach.thread.side.song', defaultMessage: 'Pitched for {song}' },
  historyTitle: { id: 'app.outreach.thread.side.history', defaultMessage: 'History' },
  historyPitched: { id: 'app.outreach.thread.side.history.pitched', defaultMessage: 'Plug pitched {song}' },
  historyListened: { id: 'app.outreach.thread.side.history.listened', defaultMessage: 'Listened {time}' },
  historyReplied: { id: 'app.outreach.thread.side.history.replied', defaultMessage: 'Replied: {label}' },
  historyAnswered: { id: 'app.outreach.thread.side.history.answered', defaultMessage: 'You answered' },
  historyAdded: { id: 'app.outreach.thread.side.history.added', defaultMessage: 'Added to {playlist}' },
  watchTitle: { id: 'app.outreach.thread.side.watch', defaultMessage: 'Plug watches' },
  watchBody: {
    id: 'app.outreach.thread.side.watchBody',
    defaultMessage: 'Plug checks the playlist every day for 60 days and tells you when {song} is on it.',
  },
  addedIt: { id: 'app.outreach.thread.side.addedIt', defaultMessage: 'They added it' },
  addedItDone: { id: 'app.outreach.thread.side.addedItDone', defaultMessage: '{song} counts as added now.' },
  openCampaign: { id: 'app.outreach.thread.side.openCampaign', defaultMessage: 'Open in the campaign' },
  neverPitch: { id: 'app.outreach.thread.side.neverPitch', defaultMessage: 'Never pitch again' },
  neverPitchDone: {
    id: 'app.outreach.thread.side.neverPitchDone',
    defaultMessage: 'Plug will never pitch {name} again.',
  },
  actionFailed: { id: 'app.outreach.thread.side.failed', defaultMessage: 'That did not work. Try again.' },
  answerLabel: { id: 'app.outreach.thread.answerLabel', defaultMessage: 'Your answer' },
  send: { id: 'app.outreach.thread.send', defaultMessage: 'Send' },
  sent: { id: 'app.outreach.thread.sent', defaultMessage: 'Sent {date}' },
  sendFailed: { id: 'app.outreach.thread.sendFailed', defaultMessage: 'We could not send the answer. Try again.' },
  markHandled: { id: 'app.outreach.thread.markHandled', defaultMessage: 'Done, no answer' },
  handled: { id: 'app.outreach.thread.handled', defaultMessage: 'Handled' },
  sayThanks: { id: 'app.outreach.thread.sayThanks', defaultMessage: 'Say thank you' },
  thanks: { id: 'app.outreach.thread.thanks', defaultMessage: 'Thank you for adding {song}. It means a lot.' },
  cannotAnswerNoMailbox: {
    id: 'app.outreach.thread.cannotAnswer.noMailbox',
    defaultMessage: 'The mailbox of this pitch is removed, so no answer can go out from MUSIC24.',
  },
  cannotAnswerMailbox: {
    id: 'app.outreach.thread.cannotAnswer.mailbox',
    defaultMessage: '{address} cannot send now. Fix it in Settings → Outreach, then answer.',
  },
  cannotAnswerStopped: {
    id: 'app.outreach.thread.cannotAnswer.stopped',
    defaultMessage:
      'This person asked to get no more emails, or the contact is set to "Do not contact". No answer goes out.',
  },
});
